import React from "react";
import classes from "./colorPicker.module.css";
import BrushIcon from "../../../../assets/img/assessmentImages/pentool.svg";
import EraserIcon from "../../../../assets/img/assessmentImages/eraser.svg";
import UndoIcon from "../../../../assets/img/assessmentImages/undo.svg";
import Popover from "@material-ui/core/Popover";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import LensIcon from "@material-ui/icons/Lens";

class ColorPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      opentools: false,
      anchorEl: null,
      color1: false,
      color2: false,
      color3: false,
      color4: false,
      color5: true
    };
  }

  openTools = event => {
    this.setState({
      opentools: !this.state.opentools,
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({ opentools: false });
  };

  inactiveAll = () => {
    this.setState({
      color1: false,
      color2: false,
      color3: false,
      color4: false,
      color5: false
    });
  };

  color1Click = () => {
    this.inactiveAll();
    this.setState({ color1: true });
    this.props.onColorSelect("#EB5142");
  };
  color2Click = () => {
    this.inactiveAll();
    this.setState({ color2: true });
    this.props.onColorSelect("#579673");
  };
  color3Click = () => {
    this.inactiveAll();
    this.setState({ color3: true });
    this.props.onColorSelect("#EF8A3B");
  };
  color4Click = () => {
    this.inactiveAll();
    this.setState({ color4: true });
    this.props.onColorSelect("#3075D2");
  };
  color5Click = () => {
    this.inactiveAll();
    this.setState({ color5: true });
    this.props.onColorSelect("black");
  };

  performUndo=()=>{
    this.props.undoaction();
  }

  clearAll=()=>{
    this.props.clearAllaction();
  }

  render() {
    return (
      <div>
        <img
          src={BrushIcon}
          alt=""
          onClick={this.openTools}
          style={{ width: 50 }}
        />
        <Popover
          open={this.state.opentools}
          anchorEl={this.state.anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          PaperProps={{
            style: {
              backgroundColor: "transparent",
              boxShadow: "none"
            }
          }}
        >
          <div className={classes.toolgrid}>
            <img src={UndoIcon} alt="" style={{ width: 30 }}  onClick={this.performUndo}/>
            <img src={EraserIcon} alt="" style={{ width: 30 }} onClick={this.clearAll}/>
            {this.state.color1 ? (
              <CheckCircleIcon
                style={{ color: "#EB5142", fontSize: 35 }}
                onClick={this.color1Click}
              />
            ) : (
              <LensIcon
                style={{ color: "#EB5142", fontSize: 35 }}
                onClick={this.color1Click}
              />
            )}
            {this.state.color2 ? (
              <CheckCircleIcon
                style={{ color: "#579673", fontSize: 35 }}
                onClick={this.color2Click}
              />
            ) : (
              <LensIcon
                style={{ color: "#579673", fontSize: 35 }}
                onClick={this.color2Click}
              />
            )}
            {this.state.color3 ? (
              <CheckCircleIcon
                style={{ color: "#EF8A3B", fontSize: 35 }}
                onClick={this.color3Click}
              />
            ) : (
              <LensIcon
                style={{ color: "#EF8A3B", fontSize: 35 }}
                onClick={this.color3Click}
              />
            )}
            {this.state.color4 ? (
              <CheckCircleIcon
                style={{ color: "#3075D2", fontSize: 35 }}
                onClick={this.color4Click}
              />
            ) : (
              <LensIcon
                style={{ color: "#3075D2", fontSize: 35 }}
                onClick={this.color4Click}
              />
            )}
            {this.state.color5 ? (
              <CheckCircleIcon
                style={{ fontSize: 35 }}
                onClick={this.color5Click}
              />
            ) : (
              <LensIcon style={{ fontSize: 35 }} onClick={this.color5Click} />
            )}
          </div>
        </Popover>
      </div>
    );
  }
}

export default ColorPicker;
